// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2wvJU","title":"ClientReferral_title__1wqOn","itemText":"ClientReferral_itemText__1XP_e"};